import { useIsAcomba } from './useIsAcomba';
import { useAcombaBridgeStore } from '../stores/acombaBridgeStore';

/**
 * Whether it is safe to trust the persisted relance access decision (dailyTasks.relanceAccessible,
 * the greeting) on an Acomba session. checkBridgeHealth() persists the *current* Usager's decision to
 * the backend before sessionStatus leaves 'idle' — reading it earlier can surface whichever Usager's
 * decision was persisted last, briefly leaking the previous Usager's access (or vice versa) right
 * after a switch.
 *
 * sessionStatus alone would never leave 'idle' while the bridge itself is unreachable (service
 * stopped/not installed) — checkSession() early-returns before touching it, per checkBridgeHealth — so
 * bridgeStatus === 'unreachable' is treated as an equally valid "first check settled".
 *
 * Always true outside Acomba: Connect's access decision is already settled server-side at login.
 */
export function useAcombaBridgeAccessReady(): boolean {
    const isAcomba = useIsAcomba();
    const bridgeStatus = useAcombaBridgeStore(s => s.bridgeStatus);
    const bridgeSessionStatus = useAcombaBridgeStore(s => s.sessionStatus);
    return !isAcomba || bridgeStatus === 'unreachable' || bridgeSessionStatus !== 'idle';
}
